import DashboardActionTypes from './DashboardActionTypes'

export interface SetProductLoading {
  type: DashboardActionTypes.SET_PRODUCT_LOADING;
  payload: {
    productKey: string
    isLoading: boolean
  }
}

export function setProductLoading({
  productKey,
  isLoading,
}: SetProductLoading['payload']): SetProductLoading {
  return {
    type: DashboardActionTypes.SET_PRODUCT_LOADING,
    payload: {
      productKey,
      isLoading,
    },
  }
}